export const APK_FILENAME = "dh-hrm-app.apk";
export const APP_VERSION = "v2.0.1";
export const ANDROID_APP_DISMISSED_VERSION_KEY =
  "dh_hrm_android_app_dismissed_version";
